import { render, staticRenderFns } from "./saleInvoiceModal.vue?vue&type=template&id=37178d20"
import script from "./saleInvoiceModal.vue?vue&type=script&lang=js"
export * from "./saleInvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./saleInvoiceModal.vue?vue&type=style&index=0&id=37178d20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports